import React, { ReactElement } from 'react';
import { AspectScoresLineChart } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/ScoresList/ScoreRow/AspectScoresLineChart/AspectScoresLineChart';
import { Flex } from 'components/Flex/Flex';
import { DivisionAspectScoresBarChart } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/ScoresList/ScoreRow/DivisionAspectScoresBarChart/DivisionAspectScoresBarChart';
import { Spacer } from 'components/Spacer/Spacer';
import styles from './ScoreRow.module.scss';

export const ScoreRow = (): ReactElement => (
  <Flex className={styles.container} flexWrap="nowrap">
    <section className={styles.fullWidth}>
      <AspectScoresLineChart />
    </section>
    <Spacer orientation="horizontal" customSize={32} />
    <section className={styles.fullWidth}>
      <DivisionAspectScoresBarChart />
    </section>
  </Flex>
);
